module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNUl8v///+dxOFHj8eFtdrn8PhsptK20unC2uzz+PvO4fB4rdZgns6RvN2py+VaVwIyAAAAB3RSTlMAYL8AIM/vi50ITwAAAKlJREFUeF7t2EkKwzAQRFGNbkmeMt//qJHBoMSLLNQFAVP/AG/dXWbLOlHkrK8Z70MUZTFsUBhE3RAqFAVQ9MYKJGscBnJGQJ0NIjQuraSApmv+6Db2Qvf83aUXmvOh1AnlY8u/oRkFFRQkKwqSR6mtOqi1nAMiRIgQIUKECBFKKKjdkqMSeu7OS5SQlOboIElTmRIfvx8Rgo0ssNkHNUTBpjHkWFdDzIdvufyTDccW2pUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/31-20e3.png
// module id = 1427
// module chunks = 0